export default __webpack_public_path__ + "static/media/bike.cf80ca82.png";